import type { Package } from '@/integrations/revenuecat/types';

export async function getAvailablePackages(): Promise<Package[]> {
  if (import.meta.env.VITE_PLATFORM === 'MOBILE') {
    const { getAvailablePackagesFromCapacitor } =
      await import('./getAvailablePackagesFromCapacitor');
    return getAvailablePackagesFromCapacitor();
  }
  const { getAvailablePackagesFromJs } =
    await import('./getAvailablePackagesFromJs');
  return getAvailablePackagesFromJs();
}
